<template>
  <v-card width="300" 
          :elevation="0"
          class="pa-5 mx-5 my-10 rounded-xl text-center app-card"
          :class="item.cardCss"
          @click="onClick">
          
          <!-- badge -->
          <Badge :item="item" class="ma-2"/>

          <!-- logo -->
          <v-img :src="item.cardImage || item.image" 
                  contain
                  height="120" />
          
          <!-- description -->
          <div v-html="item.description"
                class="mb-5 mt-10"/>
          
          <!--
          <v-btn block large>
            APRI APP
          </v-btn>
          -->
          
          <!-- disabled status -->
          <v-overlay absolute 
                     :value="item.disabled"
                     color="white"/>
    </v-card>
</template>

<style lang="scss">
    .app-card {
      transition: all .3s;
      box-shadow: 0 0 40px 0 rgba(0,0,0,.5) !important;
      // hover effect
      &:hover {
        transform: scale3d(1.03, 1.03, 1.0) translateY(-10px);
        box-shadow: 0 20px 40px 0 rgba(0,0,0,.5) !important;
      }
      // color variants
      &.gradient {
        background: linear-gradient(155deg, rgba(253,80,32,1) 0%, rgba(97,57,224,1) 50%, rgba(59,234,230,1) 100%);
      }
      &.dark {
        background: #0E1127;
        color: #9F9FBD;
      }
      // badge
      .v-chip {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 999;
      }
    }
</style>

<script>
import Badge from '@/components/Badge'
   export default {
    
    name: 'DashboardCard',

    mixins: [],

    components:
    {
      Badge
    },

    data: () => ({

    }),

    props:
    {
      item: {
        required: true
      }
    },

    computed:
    {
      
    },

    methods:
    {
      onClick()
      {
        this.$emit('click')
      }
    },

    load(){}
  }
</script>